import { ChangeLog } from '../../../types/IncentivesDataType';
import { Card, Grid, HeaderValuesType, RowValuesType } from '@cxc/react-fpds-components';
import styles from '../TabSection.module.scss';
import Table from '../../Table/Table';
import TabSectionProps from '../../../types/props/TabSectionProps';

const ChangeLogTableColumnConstants: HeaderValuesType = [
    {
        id: 'date',
        textValue: 'Date',
        contentAlignment: 'left',
    },
    {
        id: 'changes',
        textValue: 'Changes',
        contentAlignment: 'left',
    },
    {
        id: 'next-update',
        textValue: 'Next Update',
        contentAlignment: 'left',
    },
];

const ChangeLogPanel = ({ incentive }: TabSectionProps) => {
    const getRowValues = () => {
        const changeLogTableData: RowValuesType = [];
        incentive.changeLogs.forEach((changeLog: ChangeLog, index: number) => {
            changeLogTableData.push({
                rowId: `${index}`,
                cellData: [
                    {
                        textValue: changeLog.date,
                    },
                    {
                        textValue: changeLog.description,
                    },
                    {
                        textValue: changeLog.nextScheduledReview,
                    },
                ],
            });
        });
        return changeLogTableData;
    };

    return (
        <Grid className={styles.gridstyle}>
            <Grid.Item xl={12} l={12} m={12} s={12}>
                <span style={{ fontSize: '16px' }}>
                    Incentive details are updated as new information becomes available. This
                    changelog captures those changes.
                </span>
            </Grid.Item>
            <Grid.Item style={{ paddingTop: '16px' }} xl={12} l={12} m={12} s={12}>
                <Card>
                    <Table
                        headerValues={ChangeLogTableColumnConstants}
                        rowValues={getRowValues()}
                    />
                </Card>
            </Grid.Item>
        </Grid>
    );
};

export default ChangeLogPanel;
